<template lang="html">
  <section class="section">
    <nav class="navbar is-transparent is-fixed-top">
      <div class="navbar-brand">
        <router-link
          to="/"
          class="navbar-item router-link-exact-active router-link-active"
          tag="a"
        >
          <img
            style="padding: 0.5em"
            src="static/images/aino-logo.png"
            alt="Aino Michelsen"
          />
        </router-link>
      </div>
      <div class="navbar-wrapper">
        <router-link
          to="/about"
          class="navbar-item router-link-exact-active router-link-active is-hidden-desktop"
          tag="a"
        >
          About & Contact
        </router-link>
        <a
          class="navbar-item is-hidden-desktop"
          target="_blank"
          href="https://drive.google.com/drive/folders/1zRDXmwe7r8ifNoyKTTbAn95QLRJ1f25Z?usp=sharing"
          >High resolution pictures</a
        >
        <a
          class="navbar-item is-hidden-desktop"
          target="_blank"
          href="https://www.instagram.com/ainomichelsen/"
          >Follow my projects</a
        >
      </div>

      <div class="navbar-menu">
        <div class="navbar-end">
          <div class="navbar-item">
            <router-link
              to="/about"
              class="router-link-exact-active router-link-active"
              tag="a"
            >
              About & Contact
            </router-link>
          </div>
          <div class="navbar-item">
            <a
              target="_blank"
              href="https://drive.google.com/drive/folders/1zRDXmwe7r8ifNoyKTTbAn95QLRJ1f25Z?usp=sharing"
              >High resolution pictures</a
            >
          </div>
          <div class="navbar-item" style="margin-right: 1em">
            <a target="_blank" href="https://www.instagram.com/ainomichelsen/"
              >Follow my projects</a
            >
          </div>
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data: function () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signIn: function () {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          function (user) {
            console.log('Kirjauduit sisään onnistuneesti!')
          },
          function (err) {
            console.log('Jotain meni pieleen!' + err.message)
          }
        )
    }
  }
}
</script>

<style lang="css">
a {
  color: black;
}

.navbar-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: 1.5em;
  margin-bottom: 0.25em;
  gap: 0.5em;
}

.navbar-item img {
  max-height: 4.75rem;
  margin-left: 15px;
  margin-top: 10px;
}

.navbar-item {
  padding: 0.5rem 1.75rem;
}

.dropdown-content {
  border-radius: 0px !important;
  padding: 0 !important;
}

/* Add media query for smaller screens */
@media (max-width: 768px) {
  .navbar-wrapper {
    flex-direction: row;
    margin-left: 0;
    padding: 0 1.5em 0 1.5em;
    align-items: flex-start;
    height: auto;
  }

  .navbar-item {
    padding: 0.25em;
    font-size: 0.9em;
  }

  .navbar-brand {
    padding: 0;
  }

  .navbar-item img {
    max-height: 3.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue